export const InitialState = {
    list: [],
    listLoaded: false
};
